import { createEnum } from "@redotech/zod/zod-enum";

// Enum for global search categories
// Used across admin UI, command palette, and RPC filtering
export const globalSearchCategory = [
  "orders",
  "returns",
  "customers",
  "conversations",
] as const;

export type GlobalSearchCategory = (typeof globalSearchCategory)[number];

// Zod schema for validation
export const GlobalSearchCategorySchema = createEnum(globalSearchCategory);
